// @flow
import React from 'react';

import { StaticTable } from '../presentational/StaticTable';
import { Spacer } from '../presentational/spacing/Spacer';
import { TinyHeaderSpan } from '../presentational/headings/TinyHeaderSpan';

import {
  ADVANCED_SECURITY_DEFAULT_TIER_1_END_VALUE,
  ADVANCED_SECURITY_DEFAULT_TIER_1_START_VALUE,
  ADVANCED_SECURITY_DEFAULT_TIER_2_END_VALUE,
  ADVANCED_SECURITY_DEFAULT_USAGE_PERCENTAGE_VALUE,
  ADVANCED_SECURITY_TIER_END_INFINITY_PLACEHOLDER,
} from './constants';

// The default tier boundaries and usage percentage shown in the Tier End header tooltip so users can
// see what "Configure" seeds before customizing. Start = previous tier's end; Tier 1 starts at 0 and
// the last tier extends to Infinity.
const DEFAULT_TIER_VALUES_TABLE_CONTENTS = {
  headerRow: ['Tier', 'Tier Start ($)', 'Tier End ($)', '% of Usage'],
  dataRows: [
    [
      'Tier 1',
      ADVANCED_SECURITY_DEFAULT_TIER_1_START_VALUE,
      ADVANCED_SECURITY_DEFAULT_TIER_1_END_VALUE,
      ADVANCED_SECURITY_DEFAULT_USAGE_PERCENTAGE_VALUE,
    ],
    [
      'Tier 2',
      ADVANCED_SECURITY_DEFAULT_TIER_1_END_VALUE,
      ADVANCED_SECURITY_DEFAULT_TIER_2_END_VALUE,
      ADVANCED_SECURITY_DEFAULT_USAGE_PERCENTAGE_VALUE,
    ],
    [
      'Tier 3',
      ADVANCED_SECURITY_DEFAULT_TIER_2_END_VALUE,
      ADVANCED_SECURITY_TIER_END_INFINITY_PLACEHOLDER,
      ADVANCED_SECURITY_DEFAULT_USAGE_PERCENTAGE_VALUE,
    ],
  ],
};

export const DefaultTierValuesTable = () => (
  <>
    <TinyHeaderSpan headerText="Default Values" />
    <Spacer y={5} />
    <StaticTable tableContents={DEFAULT_TIER_VALUES_TABLE_CONTENTS} />
  </>
);
